module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container DocumentIndex"
  }, [(!_vm.edit.edit) ? [_c('button', {
    on: {
      "click": _vm.deleteDocument
    }
  }, [_vm._v("delete")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.switchDocument
    }
  }, [_vm._v("edit")]), _vm._v(" "), _c('div', {
    staticClass: "index-box"
  }, [_c('div', {
    staticClass: "header"
  }, [(_vm.calcUser_id) ? [_c('p', [_vm._v("user: " + _vm._s(_vm.calcUser_id.user))])] : _vm._e(), _vm._v(" "), (_vm.document.office_id) ? [_c('p', [_vm._v("office: " + _vm._s(_vm.calcOffice_id))])] : [_c('p', [_vm._v("office: admin")])], _vm._v(" "), _c('p', [_vm._v("created: " + _vm._s(_vm.calcCreated_at))]), _vm._v(" "), _c('p', [_vm._v("updated: " + _vm._s(_vm.calcUpdated_at))])], 2), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.setCategory.name))]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('div', {
    staticClass: "vue-html",
    domProps: {
      "innerHTML": _vm._s(_vm.document.note)
    }
  })])])] : [_c('button', {
    on: {
      "click": _vm.switchDocument
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.patchDocument
    }
  }, [_vm._v("update")]), _vm._v(" "), _c('div', {
    staticClass: "index-box"
  }, [_c('div', {
    staticClass: "header"
  }, [(_vm.calcUser_id) ? [_c('p', [_vm._v("user: " + _vm._s(_vm.calcUser_id.user))])] : _vm._e(), _vm._v(" "), (_vm.document.office_id) ? [_c('p', [_vm._v("office: " + _vm._s(_vm.calcOffice_id))])] : [_c('p', [_vm._v("office: admin")])], _vm._v(" "), _c('p', [_vm._v("created: " + _vm._s(_vm.calcCreated_at))]), _vm._v(" "), _c('p', [_vm._v("updated: " + _vm._s(_vm.calcUpdated_at))])], 2), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document.category),
      expression: "document.category"
    }],
    staticClass: "select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.document, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.category), function(list, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": list.value
      }
    }, [_vm._v(_vm._s(list.name))])
  }), 0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document.title),
      expression: "document.title"
    }],
    staticClass: "title",
    attrs: {
      "type": "text",
      "placeholder": "title"
    },
    domProps: {
      "value": (_vm.document.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.document.note,
      "auto-height": true
    },
    on: {
      "change": function($event) {
        return _vm.patchNote(_vm.document, $event)
      }
    }
  })], 1)])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45478272"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Document/DocumentIndex.vue
// module id = 1361
// module chunks = 0